/**
 * P / C after a customer's name when the same person has BOTH a personal and a
 * business account (owner, Oct 22 2026, about Travis Cooley and Cooley Capital:
 * "just put a P next to the personal account and C next to the commercial, just
 * so I know"). The server decides (services/twins → `account_mark`); a person
 * with one account gets nothing, so this draws nothing for them. Office pages
 * only — the crew's screens never carry the field.
 */
export type AccountMarkValue = 'P' | 'C' | null | undefined;

const WORDS: Record<'P' | 'C', string> = {
  P: 'Personal account — this person also has a business account',
  C: 'Business account — this person also has a personal account',
};

export default function AccountMark({ mark, className = '' }: { mark: AccountMarkValue; className?: string }) {
  if (mark !== 'P' && mark !== 'C') return null;
  const tone = mark === 'C'
    ? 'bg-brand-100 text-brand-800 border-brand-300'
    : 'bg-gray-100 text-gray-700 border-gray-300';
  return (
    <span
      title={WORDS[mark]}
      aria-label={WORDS[mark]}
      className={`inline-flex items-center justify-center align-middle ml-1 h-4 min-w-[1rem] px-1 rounded border text-[10px] font-black leading-none select-none ${tone} ${className}`}
    >
      {mark}
    </span>
  );
}
